<template>
  <div>
    <sideMenu @tabChange="tabChange"/>
    <Sidebar :tab-index="tabIndex"/>
  </div>
</template>
<script>
import sideMenu from '../SideMenu/index.vue'
import Sidebar from '../Sidebar/index.vue'
export default {
  name: 'LeftNavLayout',
  data () {
    return {
      tabIndex: 0
    }
  },
  components: {
    sideMenu,
    Sidebar
  },
  methods: {
    tabChange (index) {
      this.tabIndex = Number(index)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
